import { useFingerprint } from "@hooks";
import { useStore } from "@stores";
import { useEffect } from "react";

/**
 * Bootstraps the device's FCM token and syncs it with the backend.
 * 1. Asks Firebase for a fresh token (writes localStorage if changed).
 * 2. Reads the token and sends it to the backend tied to fingerprint + user.
 * Sequential, so the send always sees the freshest token.
 */
export const useFirebaseToken = () => {
  const { authStore, userStore } = useStore();
  const fingerprint = useFingerprint();
  const userId = authStore.currentUserId;

  useEffect(() => {
    if (!userId || !fingerprint) return;

    (async () => {
      try {
        // Dinamički uvoz: firebase (~40 KB gzip) ne treba anonimnim posetiocima.
        const { getFirebaseToken } = await import("../../firebase");
        await getFirebaseToken();
      } catch (err) {
        // Pretraživač bez podrške za FCM (npr. iOS Safari van PWA) — bez push-a.
        console.warn("Firebase messaging nije dostupan.", err);
        return;
      }
      const token = localStorage.getItem("fcmToken");
      if (!token) return;
      userStore.createFirebaseToken({ token, fingerprint });
    })();
  }, [userId, fingerprint, userStore]);
};
